import { type ReactNode, useMemo } from 'react';
import { Outlet } from 'react-router-dom';
import i18n from 'i18next';
import type { Tab } from 'pos-client/interfaces/tab.ts';

export const createTabs = <T extends object>(
  tabs: Record<string, Tab>,
  context: T
): Tab[] => {
  return Object.values(tabs).map(({ label, key, LabelRenderCustom }) => {
    let renderedLabel: ReactNode = i18n.t('outletTab', { tab: label });

    if (LabelRenderCustom) {
      renderedLabel = <LabelRenderCustom>{renderedLabel}</LabelRenderCustom>;
    }

    return {
      label: renderedLabel,
      key,
      children: <Outlet context={context} />,
    };
  }) as Tab[];
};

export const useTabList = (
  tabs: Record<string, Tab> | undefined,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  context: any
): Tab[] => {
  const tabList = useMemo(() => {
    if (!tabs) return [];

    return Object.values(tabs).map(({ label, key, LabelRenderCustom }) => {
      let renderedLabel: ReactNode = i18n.t('outletTab', { tab: label });

      if (LabelRenderCustom) {
        renderedLabel = <LabelRenderCustom>{renderedLabel}</LabelRenderCustom>;
      }

      return {
        label: renderedLabel,
        key,
        children: <Outlet context={context} />,
      };
    }) as Tab[];
  }, [tabs]);

  return tabList;
};
